module.exports = __webpack_public_path__ + "bin/2d373e2bda468649b568085785809539.woff";